skrilla.controller('dataCtrl', function ($scope, searchService, cacheService, dateService, queryService, modalService, srefService, $stateParams, sportService) {
    $scope.sports = [];
    sportService.getSports().then(function(sports){
        $scope.sports = sports;
    })
    $scope.key = "data";
    $scope.tabs = [
        {title: "Sports", active: false},
        {title: "Matches", active: false},
        {title: "Tournaments", active: false},
        {title: "Franchises", active: false},
        {title: "Players", active: false}
    ];
    $scope.sport = $stateParams.sport;

    $scope.select = function (sport) {
        if (sport) {
            srefService.go("sportData", {sport: sport.name});
            modalService.dismissAll();
        }
    }

    if($scope.sport !== undefined && $scope.sport !== null && $scope.sport !== ""){
        $scope.seasons = cacheService.getObjectOrElse($scope.sport + "Seasons", []);
        cacheService.registerObject("contestSport", $scope.sport);
    }

    $scope.navigateMatches = function(season, match){
        srefService.go( "matchDetails", {id: match.id});
    }

    $scope.navigatePlaceholders = function(placeholder){
        srefService.go("matchPlaceholderDetails", {id: placeholder.id, sport: $scope.sport});
    }

    $scope.navigateTournaments = function(id){
        srefService.go("tournamentDetails", {id: id, sport: $scope.sport});
    }

    $scope.navigateFranchises = function(franchise){
        srefService.go("franchiseDetails", {id: franchise.id});
    }

    $scope.navigatePlayers = function(id){
        srefService.go("playerDetails", {id: id});
    }

    $scope.createMatch = function(){
        srefService.go("createMatch", {sport: $scope.sport})
    }
    $scope.createTournament = function() {
        modalService.openModal("views/createTournament/createTournament.html", true, 'lg', true, true);
    }

    $scope.createFranchise = function() {
        modalService.openModal("views/createFranchise/createFranchise.html", true, 'lg', true, true);
    }

    $scope.createPlayer = function() {
        modalService.openModal("views/createPlayerModal/createPlayerModal.html", true, 'lg', true, true);
    }

});
